import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks';
import { Button, Icon } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

import { isOffline as isOfflineSelector } from 'modules/healthCheck/selectors';
import { isCourtesyUnavailable, hasErrorOnKiosk } from 'modules/dealers/selectors';

import type { HomeButtonProps } from './index';

const FROM_HOME_ANALYTICS = {
  category: 'Login',
  action: 'From home login',
  label: 'Login started',
};

const FROM_DEALERSHIP_ANALYTICS = {
  category: 'Login',
  action: 'From the dealership login',
  label: 'Login started',
};

const SelfServiceTypeButtons: React.FC<HomeButtonProps> = ({ onClick }) => {
  const isOffline = useSelector(isOfflineSelector);
  const hasKioskError = useSelector(hasErrorOnKiosk);
  const isCourtesyNotAvailable = useSelector(isCourtesyUnavailable);

  const isFromDealershipDisabled = hasKioskError || isCourtesyNotAvailable;

  const handleClick = React.useCallback((atDealership: boolean) => () => onClick({ atDealership }), [onClick]);

  return (
    <div
      className="flex flex-col items-start w-full m-auto pt-6 pb-12 max-w-4xl px-7"
    >
      <Button
        disabled={isOffline}
        type={ButtonType.PRIMARY}
        testId="from-home-button"
        onClick={handleClick(false)}
        analytics={FROM_HOME_ANALYTICS}
        className="flex items-center justify-between w-full mb-6 !drop-shadow-md !p-1.5 !pl-12 btn-home-primary"
      >
        <FormattedMessage id="home.fromHome" defaultMessage="From home" />
        <div className="flex justify-center items-center size-btn-primary-icon-home rounded-button bg-btn-primary-icon-bg">
          <Icon className="fb-icon--arrow-right text-xl kiosk:text-2xl text-btn-home-primary-icon-text" />
        </div>
      </Button>
      <Button
        disabled={isOffline}
        type={ButtonType.PRIMARY}
        testId="from-dealer-button"
        onClick={handleClick(true)}
        analytics={FROM_DEALERSHIP_ANALYTICS}
        disabledStyle={isFromDealershipDisabled}
        className="flex items-center justify-between w-full mb-6 !drop-shadow-md !p-1.5 !pl-12 btn-home-primary"
      >
        <FormattedMessage id="home.fromDealer" defaultMessage="From the dealership" />
        <div className="flex justify-center items-center size-btn-primary-icon-home rounded-button bg-btn-primary-icon-bg">
          <Icon className="fb-icon--arrow-right text-xl kiosk:text-2xl text-btn-home-primary-icon-text" />
        </div>
      </Button>
    </div>
  );
};

export default SelfServiceTypeButtons;
